var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['draw-item',{'got': _vm.$attrs.drawn}]},[_c('Item',_vm._g(_vm._b({class:[{'current-draw':_vm.$attrs.currentItemIndex.indexOf(_vm.$attrs.index)>-1}],attrs:{"type":"draw"}},'Item',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c352249","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/drawitem/index.vue
// module id = null
// module chunks = 